import React, {useEffect, useState} from 'react';
import {
    getModelTags,
    getModelVersion,
    getRepositories,
    previewDataModelAPI,
    saveDataModel,
    searchAllModels
} from "../../../api/DataModel/data-model";

import LoadingScreen from "../../../containers/LoadingScreen/LoadingScreen";
import Aux from "../../../hoc/Auxiliary";
import HeaderBreadCrumb from "../../BreadCrumb/Breadcrumb";
import {useNavigate, useParams} from "react-router-dom";
import classes from "./GeneralSettings/GeneralSettings.module.css";
import {InputText} from "primereact/inputtext";
import {removeNonUtf8} from "../../../api/utils/Strings";
import {checkVersionNameValidity} from "../../../api/utils/pemmdb-version-form";
import {InputTextarea} from "primereact/inputtextarea";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {showError, showSuccess} from "../../../api/notification/ToastManager";
import {StatusCode} from "../../../entities/StatusContext";
import {onServerCallError} from "../../../api/utils/errors";
import {InputIcon} from "primereact/inputicon";

const NewPEMMDBVersion = () => {
    const {version} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [modelTags, setModelTags] = useState([]);
    const [roots, setRoots] = useState(["PEMMDB Versions"]);
    const [existingModels, setExistingModels] = useState([])
    const navigate = useNavigate();
    const [isPublishing, setIsPublishing] = useState(false)
    const [editable, setEditable] = useState(true)
    const [newModel, setNewModel] = useState({
        name: '',
        tag: '',
        description: '',
        previousName: ''
    })
    const [retrievingTags, setRetrievingTags] = useState(false)

    const [repositories, setRepositories] = useState([])
    const [selectedRepository, setSelectedRepository] = useState({
        full_name: ""
    })

    const [tagsDropdownOpen, setTagsDropdownOpen] = useState(false)

    useEffect(() => {
        if (tagsDropdownOpen) {
            const input = document.querySelector('#ref .p-dropdown-panel input.p-dropdown-filter');
            if (input) {
                input.focus();
                const panel = document.querySelector('#ref .p-dropdown-panel');
                const keepFocus = () => {
                    if (document.activeElement !== input) {
                        input.focus();
                    }
                };
                panel?.addEventListener('mousemove', keepFocus);
                return () => {
                    panel?.removeEventListener('mousemove', keepFocus);
                };
            }
        }
    }, [tagsDropdownOpen]);

    const tasks = [
        {
            promise: searchAllModels,
            name: 'PEMMDB Existing Models',
            updateMethod: setExistingModels,
            postCall: (data) => {
                if (version !== undefined && version !== null && version !== "") {
                    getModelVersion(version).then(r => {
                        if (r) {
                            setEditable(r.modelStatus.code !== "PUBLISHED")
                            setNewModel({
                                name: r.name,
                                previousName: r.name,
                                tag: r.tag,
                                description: r.description,
                            })
                            setSelectedRepository({full_name: r.repositoryName})
                            setExistingModels([...data.filter(model => model.name !== version)]);
                        }
                    })
                }
            }
        },
        {
            promise: getRepositories,
            name: 'PEMMDB GIT repository',
            updateMethod: setRepositories,
            postCall: (_) => {
            }
        }

    ];

    useEffect(() => {
        const fetchData = async () => {

            const results = await Promise.allSettled(tasks.map(task => task.promise()));
            results.forEach((result, index) => {
                const {name, updateMethod, postCall} = tasks[index];
                if (result.value.status !== 500) {
                    updateMethod(result.value.content)
                    postCall(result.value.content)
                } else {
                    onServerCallError(`Failed to retrieve ${name}:`, `An error occurs while retrieving ${name}`, goBack);
                }
            });
            setIsLoading(false);
        }
        fetchData()

    }, [version]);

    useEffect(() => {
        if (selectedRepository.full_name !== "") {
            setRetrievingTags(true)
            getModelTags(selectedRepository.full_name)
                .then((result) => {
                    setModelTags(result.content)
                })
                .finally(() => {
                    setRetrievingTags(false)
                })
        } else {
            setModelTags([])
        }
    }, [selectedRepository]);

    useEffect(() => {
        if (version !== undefined && version !== null && version !== "") {
            setRoots([...roots, version])
        } else
            setRoots([...roots, "new"])
    }, [version]);

    const [loadingPreview, setLoadingPreview] = useState(false)

    const [modelValidity, setModelValidity] = useState({
        isValid: true,
        errorMessage: '',
        context: ""
    })


    const goBack = () => {
        navigate('/pemmdb_versions')
    }

    useEffect(() => {
        const [validity, message] = checkNameValidity(existingModels, newModel.name)
        setModelValidity({
            isValid: validity && newModel.tag !== "",
            errorMessage: message,
            context: "PEMMDB Version name"
        })
    }, [newModel]);


    const checkNameValidity = (existingVersions, modelName) => {
        const [validity, message] = checkVersionNameValidity(modelName,
            existingVersions.map(version => {
                return version.name
            }),
            modelTags)
        return [validity, message]
    }

    const saveModelAs = (status, code, message, callbackOnSuccess, callbackOnFail) => {
        let dataModel = {
            "id": 0,
            "name": newModel.name,
            "description": newModel.description,
            "createdIn": '',
            "tag": newModel.tag,
            "repositoryName": selectedRepository.full_name,
            "action": status,
            previousName: newModel.previousName,
        };

        saveDataModel(dataModel).then(result => {
            triggerNotification(newModel.name, result, message);
            callbackOnSuccess()
        }).catch(e => {
            callbackOnFail(e)
        })
    }

    function triggerNotification(name, result, state) {
        if (result.data.status === 204 || result.data.status === 500) {
            showError("Error", "An error occurs when creating PEMMDB Version: " + result.data.message);
            setIsPublishing(false);
        } else if (result.data.status === 200) {
            showSuccess("Success", "Pemmdb version " + name + " is " + state);
            navigate("/pemmdb_versions");
        }


    }

    const savePublished = () => {
        setIsPublishing(true);
        saveModelAs("PUBLISH", StatusCode.DRAFT, "published",
            () => {
                navigate("/pemmdb_versions");
            },
            (e) => {
                setIsPublishing(false);
                showError("Error", e.response.data.message)
            })
    }

    const saveDraft = () => {
        setIsPublishing(true);
        saveModelAs(StatusCode.DRAFT, StatusCode.DRAFT, "saved", () => {
        }, (_) => {
            setIsPublishing(false);
            showError("Error", "An error occurred when saving " + newModel.name + " PEMMDB version")
        })
    }


    function previewDataModel() {
        setLoadingPreview(true)
        previewDataModelAPI(newModel.tag, selectedRepository.full_name)
            .then(async result => {
                const blob = new Blob([result], {type: "application/pdf"});
                const url = window.URL.createObjectURL(blob);
                window.open(url, "_blank");
            }).catch(_ => {
            // showError("Error", "An error occurs when retrieving the preview of the model")
        })
            .finally(() => {
                setLoadingPreview(false)
            })
    }


    return (
        isLoading
            ? (<LoadingScreen/>)
            : isPublishing ?
                <LoadingScreen>
                    <h2 className={classes.progressTitle}>Publishing PEMMDB Version In Progress ...</h2>
                </LoadingScreen>
                : <Aux>
                    <HeaderBreadCrumb items={roots}/>
                    <h3>Setup PEMMDB Version</h3>
                    <p>Create new PEMMDB Version or edit an existing PEMMDB Version. </p>
                    <Aux>
                        <h4 className={classes.title}>General Settings</h4>
                        <p><b>PEMMDB Version name</b></p>
                        <InputText
                            disabled={!editable}
                            className={classes.dropDown}
                            value={newModel.name}

                            onChange={(e) => {
                                if (e.nativeEvent.data === null
                                    || e.nativeEvent?.data?.match(/^[-_a-zA-Z0-9]+$/) !== null) {
                                    const value = removeNonUtf8(e.target.value);
                                    setNewModel({...newModel, name: value})
                                }
                            }}
                            placeholder="name"/>
                        {modelValidity.isValid === false && modelValidity.context === "PEMMDB Version name" ?
                            <small
                                className="p-error block">{modelValidity.errorMessage}</small> : <></>}

                        <p><b>Description</b></p>
                        <InputTextarea
                            disabled={!editable}
                            rows={7} className={classes.textArea}
                            value={newModel.description}
                            onChange={(e) => {
                                setNewModel({...newModel, description: e.target.value})
                            }}/>

                        <p><b>Remote reference</b></p>
                        <Dropdown
                            disabled={!editable || retrievingTags}
                            className={classes.dropDown}
                            value={selectedRepository}
                            filter={true}
                            appendTo="self"
                            onShow={() => {
                                setTagsDropdownOpen(true)
                            }}
                            onHide={() => {
                                setTagsDropdownOpen(false)
                            }}
                            optionLabel={"full_name"}
                            options={repositories}
                            onChange={(e) => {
                                setNewModel({
                                    ...newModel,
                                    tag: ''
                                })
                                setModelTags([])
                                setSelectedRepository(e.value)
                            }}
                            placeholder="Repository reference"/>

                        <p style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                            <b>Model reference</b>
                            {retrievingTags && <InputIcon className="pi pi-spin pi-spinner ml-2"> </InputIcon>}
                        </p>
                        <div className={classes.tool} id="ref">
                            <Dropdown
                                disabled={!editable || modelTags.length === 0}
                                className={classes.dropDown}
                                value={newModel.tag}
                                filter={true}
                                appendTo="self"
                                onShow={() => {
                                    setTagsDropdownOpen(true)
                                }}
                                onHide={() => {
                                    setTagsDropdownOpen(false)
                                }}
                                options={modelTags}
                                onChange={(e) => {
                                    setNewModel({...newModel, tag: e.value})
                                }}
                                placeholder="Model reference"/>
                            <Button className={classes.actionBtn}
                                    onClick={() => {
                                        previewDataModel()
                                    }}
                                    disabled={newModel.tag === ""}
                                    label={"Preview Model Documentation"}
                                    loading={loadingPreview}
                            />
                        </div>
                    </Aux>

                    <div className={classes.buttons}>
                        <Button
                            className={classes.actionBtn} style={{textWrap: "nowrap"}}
                            label="Publish PEMMDB version"
                            onClick={() => {
                                savePublished()
                            }}
                            tooltip={"publish"}
                            tooltipOptions={{position: 'top', showOnDisabled: true}}
                            disabled={!modelValidity.isValid || !editable || loadingPreview}
                        />
                        <Button className={classes.actionBtn}
                                label="Save Draft"

                                onClick={() => {
                                    saveDraft()
                                }}
                                disabled={!modelValidity.isValid || !editable || loadingPreview}/>

                        <Button className={classes.actionBtn}
                                label="Abort"
                                onClick={() => {
                                    navigate('/pemmdb_versions')
                                }}
                                disabled={isPublishing || !editable || loadingPreview}
                        />
                    </div>

                </Aux>
    )
};

export default NewPEMMDBVersion;